import IChartData from "../../interfaces/IChartData";
import IParkingAvailabilityModel from "../../interfaces/IParkingAvailabilityModel";
import { DevDocActionTypes, SET_CHART_DATA, SET_DATE_TIME, SET_FACILITY_NAME, SET_FULL_YEAR_LOCATION_DATA, SET_LOCATIONS, SET_PARKING_AVAILABILITY_MODEL, SET_PARKING_AVAILABILITY_MODELS } from "./types";

export function setDateTime(dateTime: Date): DevDocActionTypes {
    return {
        type: SET_DATE_TIME,
        payload: {
            dateTime
        }
    } as const
}

export function setFacilityName(facilityName: string): DevDocActionTypes {
    return {
        type: SET_FACILITY_NAME,
        payload: {
            facilityName
        }
    } as const
}

export function setParkingAvailabilityModel(parkingAvailabilityModel: IParkingAvailabilityModel): DevDocActionTypes {
    return {
        type: SET_PARKING_AVAILABILITY_MODEL,
        payload: {
            parkingAvailabilityModel
        }
    } as const
}


export function setLocations(locations: string[]): DevDocActionTypes {
    return {
        type: SET_LOCATIONS,
        payload: {
            locations
        }
    } as const
}


export function setParkingAvailabilityModels(parkingAvailabilityModels: Array<IParkingAvailabilityModel>): DevDocActionTypes {
    return {
        type: SET_PARKING_AVAILABILITY_MODELS,
        payload: {
            parkingAvailabilityModels
        }
    } as const
}

export function setChartData(chartData: Array<IChartData>): DevDocActionTypes {
    return {
        type: SET_CHART_DATA,
        payload: {
            chartData
        }
    } as const
}

export function setFullYearLocationData(fullYearLocationData: Array<IChartData>): DevDocActionTypes {
    return {
        type: SET_FULL_YEAR_LOCATION_DATA,
        payload: {
            fullYearLocationData
        }
    } as const
}